import { Component } from '@angular/core';
import { MasterService } from '../../@core/services/master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '../../@core/services/role.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NbToastrService } from '@nebular/theme';


@Component({
  selector: 'ngx-part-sync',
  templateUrl: './part-sync.component.html',
  styleUrls: ['./part-sync.component.scss']
})
export class PartSyncComponent {


  userRole: any;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  selectedPriceData: any;
  selectedPriceRowIndex: number | null = null;
  finalConvertedData: any = [];
  sourceListData: any[] = [];
  GrossprojectQty: any;
  confirmModal: any;
  isConfirmEnabled: boolean = false;
  isTableEnabled: boolean = false;
  headerInforData: any;
  headerInfo: any;
  currentStage: string = '';
  projectId: any;
  grossPrice = 0;
  versionId: any;

  // For the first table
  sortColumnTable1: string = '';
  sortDirectionTable1: 'asc' | 'desc' = 'asc';

  // For the second table
  sortColumnTable2: string = '';
  sortDirectionTable2: 'asc' | 'desc' = 'asc';
  ngOnInit() {
    this.userRole = this.roleService.getUserRole();
    this.loadData();
  }

  constructor(private router: Router,
    private masterService: MasterService,
    private modalService: NgbModal,
    private roleService: RoleService,
    private notify: NbToastrService,
    private route: ActivatedRoute
  ) {

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.sourceListData = navigation.extras.state.filterInfo;
      this.GrossprojectQty = navigation.extras.state.headerInfo.GrossprojectQty;
      this.headerInforData = navigation.extras.state.headerInfo;
      this.currentStage = navigation.extras.state.currentStage;
      // this.projectId = navigation.extras.state.projectId;
      this.projectId = navigation.extras.state.projectId;        // This is project_ids array
      this.versionId = navigation.extras.state.versionId;
      this.selectedCustomerIds = navigation.extras.state.selectedCustomerIds || [];
      this.selectedCustomerNames = navigation.extras.state.selectedCustomerNames || [];

    }
    // history.replaceState({}, '')

  }
  loadData() {
    this.sourceListData = this.sourceListData.map(row => {
      const closestQty = Number(row.Closest_Quantity || 0);
      const qty = Number(row.projectQty ?? row.quantity ?? 0);
      const landingCost = Number(row.landing_cost ?? row.Landing_Cost ?? row.Landing_Cost_INR ?? 0);

      return {
        ...row,
        variance: +(row.ConvertedPrice || 0) * Math.max(closestQty, qty),
        total_landing_cost: landingCost * Math.max(closestQty, qty)
      } as any;
    });
  }

  get totalSum(): number {
    return this.sourceListData?.reduce((sum, row) => sum + (row.variance || 0), 0);
  }
  get selectedRowVariance(): number {
    if (this.selectedPriceRowIndex !== null && this.finalConvertedData?.[this.selectedPriceRowIndex]) {
      return this.finalConvertedData[this.selectedPriceRowIndex]?.variance || 0;
    }
    return 0;
  }



  sortData(column: string, table: number) {
    if (table === 1) {
      // Sorting for Table 1
      if (this.sortColumnTable1 === column) {
        this.sortDirectionTable1 = this.sortDirectionTable1 === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumnTable1 = column;
        this.sortDirectionTable1 = 'asc';
      }

      this.sourceListData.sort((a, b) => {
        const valA = a[column] ?? '';
        const valB = b[column] ?? '';

        if (typeof valA === 'number' && typeof valB === 'number') {
          return this.sortDirectionTable1 === 'asc' ? valA - valB : valB - valA;
        }

        return this.sortDirectionTable1 === 'asc'
          ? valA.toString().localeCompare(valB.toString())
          : valB.toString().localeCompare(valA.toString());
      });

    } else if (table === 2) {
      // Sorting for Table 2
      if (this.sortColumnTable2 === column) {
        this.sortDirectionTable2 = this.sortDirectionTable2 === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumnTable2 = column;
        this.sortDirectionTable2 = 'asc';
      }

      this.finalConvertedData.sort((a: any, b: any) => {
        const valA = a[column] ?? '';
        const valB = b[column] ?? '';

        if (typeof valA === 'number' && typeof valB === 'number') {
          return this.sortDirectionTable2 === 'asc' ? valA - valB : valB - valA;
        }

        return this.sortDirectionTable2 === 'asc'
          ? valA.toString().localeCompare(valB.toString())
          : valB.toString().localeCompare(valA.toString());
      });
    }
  }
  getSortIcon(column: string, table: number) {
    if (table === 1) {
      if (this.sortColumnTable1 !== column) {
        return 'fa fa-sort';
      }
      return this.sortDirectionTable1 === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
    } else if (table === 2) {
      if (this.sortColumnTable2 !== column) {
        return 'fa fa-sort';
      }
      return this.sortDirectionTable2 === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
    }
    return '';
  }



  home() {
    // debugger
    if (this.userRole === 'Engineer') {
      this.router.navigate(['/dashboard-engineer'])
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      this.router.navigate(['/dashboard-manager'])
    }
  }
  // openPopup() {
  //   this.isTableEnabled = true;
  // }
  getISTTimestamp() {
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const istOffset = 5.5 * 60 * 60000; // 5.5 hours in ms
    const istDate = new Date(utc + istOffset);

    const yyyy = istDate.getFullYear();
    const MM = String(istDate.getMonth() + 1).padStart(2, '0');
    const dd = String(istDate.getDate()).padStart(2, '0');
    const hh = String(istDate.getHours()).padStart(2, '0');
    const mm = String(istDate.getMinutes()).padStart(2, '0');
    const ss = String(istDate.getSeconds()).padStart(2, '0');

    return `${yyyy}${MM}${dd}${hh}${mm}${ss}`;
  }


  consolidationId: string = '';

  openPopup() {
    this.isTableEnabled = true;

    const data = this.sourceListData[0]; // sample part data
    // const Consilidation_name = this.getISTTimestamp();
    const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');

    const payload = {
      project_ids: this.projectId || [],        // Include project_ids here
      version_ids: this.versionId || [],
      // Consilidation_name = this.getISTTimestamp();
      procurement_version_ids: [
        0
      ],
      engineer_id: currentUser?.engineer_id || currentUser?.user_id || 0,
      manager_id: currentUser?.manager_id || currentUser?.user_id || 0,
      // Include version_ids here
      data: [
        {
          part_header: {
            internalPartNo: data?.internalPartNo || '',
            customerPartNumber: data?.customerPartNumber || '',
            description: data?.description || '',
            commodity: data?.commodity || '',
            uom: data?.uom || '',
            projectQty: this.GrossprojectQty,
            iSourcing: data?.iSourcing || '',
            stockAvailability: data?.stockAvailability || 0,
            leadTime: data?.leadTime || 0,
            minimumPrice: data?.minimumPrice || 0,
            eau: data?.eau || 0
          },
          Parts: [{
            specification: data?.MPN || '',
            manufacturer: (data?.manufacturer && data.manufacturer !== "N/A") ? data.manufacturer : "undefined"
          }]
        }
      ],
      sourcing_types: ["vendor"]
    };


    this.masterService.get_sync_consolidation_parts(payload).subscribe((res: any) => {
      const data = res.Sync_Complete_data[0];
      const syncPartsHeader = data?.Sync_parts_header;

      console.log('_id from response:', syncPartsHeader?._id);

      this.consolidationId = syncPartsHeader?._id || '';

      this.finalConvertedData = data.Consolidated_ranked_parts.map((row: any) => ({
        supplier: row.company?.name || '',
        manufacturer: syncPartsHeader?.manufacturer || '',
        Inventorylevel: row.totalAvail || 0,
        uom: syncPartsHeader?.uom || '',
        Price: row.unitPrice || 0,
        Currency: row.currency || '',
        Closest_Quantity: row.moq || 0,
        estimatedFactoryLeadDays: row.factoryLeadDays || 0,
        // variance: row.unitPrice * Math.max(row.moq, syncPartsHeader?.projectQty || 0),
        // variance: row.price_in_inr * Math.max(row.moq || 0, this.GrossprojectQty || 0),
        Total_cost: row.Total_cost || 0,

        MPN: syncPartsHeader?.MPN || '',
        Price_INR: syncPartsHeader?.Price_INR || 0,
        Landing_Cost_INR: syncPartsHeader?.Landing_Cost_INR || 0
      }));
    });


  }

  onConfirm() {
    if (this.selectedPriceRowIndex == null) {
      this.notify.warning('No Selection', 'Please select a supplier before confirming.');
      return;
    }

    const selectedRow = this.finalConvertedData[this.selectedPriceRowIndex];
    const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');


    const createdDate = new Date().toISOString();


    const payload = [
      {
        consolidationId: this.consolidationId,
        createdDate: createdDate,
        MPN: selectedRow.MPN,
        engineer_id: currentUser?.engineer_id || currentUser?.user_id || 0,
        manager_id: currentUser?.manager_id || currentUser?.user_id || 0,
        grossQuantity: this.GrossprojectQty,
        consideredSuppplier: selectedRow?.supplier,

        Inventorylevel: selectedRow?.Inventorylevel,
        Price: selectedRow?.Price,
        Currency: selectedRow?.Currency,
        Price_INR: selectedRow?.Price_INR,
        // Landing_Cost_INR: selectedRow?.Landing_Cost_INR,
        Landing_Cost_INR: String(selectedRow?.Landing_Cost_INR || '0'),
        Total_cost: String(selectedRow?.Total_cost ?? '0'),
        Closest_Quantity: selectedRow?.Closest_Quantity,
        leadTime: selectedRow?.estimatedFactoryLeadDays,
        costSaving: this.grossPrice,


        details: this.sourceListData.map(item => ({
          projectName: item?.projectName,
          currentStage: this.currentStage,
          internalPartNo: item?.internalPartNo,
          quantity: item?.projectQty,
          // quantity: Math.round(item?.projectQty || 0),
          expectedCompletionDate: item?.expectedCompletionDate,
          Supplier: item?.supplier,
          Price: item?.Price,
          Currency: item?.Currency,
          Price_INR: item?.Price_INR || item?.price_in_inr || selectedRow?.Price_INR || 0,
          Landing_Cost_INR: String(item?.Landing_Cost_INR || item?.landing_cost || selectedRow?.Landing_Cost_INR || '0'),
          Total_cost: String(
            item?.variance ?? selectedRow?.variance ?? '0'
          ),
          Closest_Quantity: item?.Closest_Quantity,
          leadTime: item?.leadTime

        }))
      }
    ];

    console.log('Confirm Payload:', payload);

    this.masterService.save_sync_cosolidate_final_part(payload).subscribe({
      next: (res) => {
        this.notify.success('Success', 'Sync project saved successfully.');
        this.modalService.dismissAll();
      },
      error: (err) => {
        console.error('Save failed', err);
        this.notify.danger('Error', 'Failed to save sync project.');
      }
    });
  }


  onSave() {
    console.log('Changes saved');
    this.modalService.dismissAll();
  }


  selectPriceRow(index: number, row: any) {
    this.selectedPriceRowIndex = index;
    this.isConfirmEnabled = true;
    this.grossPrice = this.totalSum - (row?.Total_cost || 0);
  }
  selectedCustomerIds: any[] = [];
  selectedCustomerNames: string[] = [];

  back() {
    console.log('Sending state on back:', {
      headerInfo: this.headerInforData,
      currentStage: this.currentStage,
      projectId: this.projectId,
      selectedCustomerIds: this.selectedCustomerIds,
      selectedCustomerNames: this.selectedCustomerNames
    });


    if (this.userRole === 'Engineer') {
      this.router.navigate(['/smart-sync'], {
        state: {
          headerInfo: this.headerInforData,
          currentStage: this.currentStage,
          projectId: this.projectId,
          selectedCustomerIds: this.selectedCustomerIds,
          selectedCustomerNames: this.selectedCustomerNames
        }
      });
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      this.router.navigate(['/smart-sync'], {
        state: {
          headerInfo: this.headerInforData,
          currentStage: this.currentStage,
          projectId: this.projectId,
          selectedCustomerIds: this.selectedCustomerIds,
          selectedCustomerNames: this.selectedCustomerNames
        }
      })
    }
  }
}
